import { Button } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { SpinnerIcon } from '../../../../../../../../components/Commons/SpinnerIcon/styles';
import {
  TrackingContainer,
  TrackingTimeline
} from '../../../../../../../../components/Commons/Tables/TrackingOrder/styles';
import { loadTrackingFlatSteel } from '../../../../../../../../store/ducks/long-steel-orders/actions';
import { IOpenOrderData } from '../../../../../../../../store/ducks/long-steel-orders/types';
import { ProductionAlert } from './styles';

interface ITrackingFlatSteelProps {
  item: IOpenOrderData;
}

const TrackingFlatSteel: React.FC<ITrackingFlatSteelProps> = ({ item }) => {
  const dispatch = useDispatch();

  const loadTracking = () => {
    dispatch(loadTrackingFlatSteel(item));
  };

  useEffect(() => {
    if (!item.trackingFlatSteel) {
      loadTracking();
    }
  });

  return (
    <TrackingContainer>
      {item.trackingFlatSteel &&
        !item.trackingFlatSteel.loading &&
        item.trackingFlatSteel.error && (
          <div className="tracking-error">
            <span>Falha ao obter as informações de tracking.</span>
            <Button onClick={loadTracking}>Tentar novamente</Button>
          </div>
        )}

      {(!item.trackingFlatSteel || item.trackingFlatSteel.loading) && (
        <SpinnerIcon />
      )}

      {item.trackingFlatSteel &&
        !item.trackingFlatSteel.loading &&
        item.trackingFlatSteel.flatsteel && (
          <>
            <div className="status">
              <h4>
                <strong>Saldo da ordem</strong>
              </h4>
              <span>{item.trackingFlatSteel.flatsteel.openQuantity}t</span>
            </div>

            <TrackingTimeline>
              <div>
                <span>{`${
                  item.trackingFlatSteel.flatsteel.meltShop > 0
                    ? item.trackingFlatSteel.flatsteel.meltShop + 't'
                    : ''
                }`}</span>
                <div
                  className={`dot ${
                    item.trackingFlatSteel.flatsteel.meltShop ? '' : 'disabled'
                  }`}
                ></div>
                <h4>Aciaria</h4>
              </div>

              <div>
                <span>{`${
                  item.trackingFlatSteel.flatsteel.rollingMill > 0
                    ? item.trackingFlatSteel.flatsteel.rollingMill + 't'
                    : ''
                }`}</span>
                <div
                  className={`dot ${
                    item.trackingFlatSteel.flatsteel.rollingMill
                      ? ''
                      : 'disabled'
                  }`}
                ></div>
                <h4>Laminação</h4>
              </div>

              <div>
                <span>{`${
                  item.trackingFlatSteel.flatsteel.rollingFinish > 0
                    ? item.trackingFlatSteel.flatsteel.rollingFinish + 't'
                    : ''
                }`}</span>
                <div
                  className={`dot ${
                    item.trackingFlatSteel.flatsteel.rollingFinish
                      ? ''
                      : 'disabled'
                  }`}
                ></div>
                <h4>LA</h4>
              </div>

              <div>
                <span>{`${
                  item.trackingFlatSteel.flatsteel.finish > 0
                    ? item.trackingFlatSteel.flatsteel.finish + 't'
                    : ''
                }`}</span>
                <div
                  className={`dot ${
                    item.trackingFlatSteel.flatsteel.finish ? '' : 'disabled'
                  }`}
                ></div>
                <h4>Acabamento</h4>
              </div>

              <div>
                <span>{`${
                  item.trackingFlatSteel.flatsteel.stockMill > 0
                    ? item.trackingFlatSteel.flatsteel.stockMill + 't'
                    : ''
                }`}</span>
                <div
                  className={`dot ${
                    item.trackingFlatSteel.flatsteel.stockMill ? '' : 'disabled'
                  }`}
                ></div>
                <h4>Estoque usina</h4>
              </div>

              <div>
                <span>{`${
                  item.trackingFlatSteel.flatsteel.transit > 0
                    ? item.trackingFlatSteel.flatsteel.transit + 't'
                    : ''
                }`}</span>
                <div
                  className={`dot ${
                    item.trackingFlatSteel.flatsteel.transit ? '' : 'disabled'
                  }`}
                ></div>
                <h4>Em transferência</h4>
              </div>

              <div>
                <span>{`${
                  item.trackingFlatSteel.flatsteel.stockWarehouse > 0
                    ? item.trackingFlatSteel.flatsteel.stockWarehouse + 't'
                    : ''
                }`}</span>
                <div
                  className={`dot ${
                    item.trackingFlatSteel.flatsteel.stockWarehouse
                      ? ''
                      : 'disabled'
                  }`}
                ></div>
                <h4>Estoque entre-posto</h4>
              </div>
            </TrackingTimeline>

            {item.trackingFlatSteel.flatsteel.productionAlert && (
              <ProductionAlert
                className={
                  item.trackingFlatSteel.flatsteel.productionAlert === '1'
                    ? 'in-time'
                    : item.trackingFlatSteel.flatsteel.productionAlert === '2'
                    ? 'possible-late'
                    : 'late'
                }
              >
                <span className="text">
                  {item.trackingFlatSteel.flatsteel.productionAlert === '1'
                    ? 'No prazo'
                    : item.trackingFlatSteel.flatsteel.productionAlert === '2'
                    ? 'Possível atraso'
                    : 'Em atraso'}
                </span>
              </ProductionAlert>
            )}
          </>
        )}
    </TrackingContainer>
  );
};

export default TrackingFlatSteel;
